import React, { useEffect } from 'react'
import NavbarTop from './../components/global/NavbarTop';
import DevelopersContent from '../components/Developers/DevelopersContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from './../redux/language/selector';

const Developers = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('developers-page.developers-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
        <NavbarTop/>
        <DevelopersContent/>
        
    </>
  )
}

export default Developers